import ActionTypes from "actions/ActionTypes";

const initialState = {
  siteStatistic: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SITE_STATISTIC_SUCCESS: {
      return {
        ...state,
        siteStatistic: payload.data,
      };
    }
    default:
      return state;
  }
};
